// This module must load FIRST so that window.jQuery exists before
// DataTables 3.x checks it during its module evaluation.
import $ from 'jquery';
window.jQuery = $;
window.$ = $;
